<script setup lang="ts">
import BaseIconLoader from '@/presentation/components/base/iconLoader/BaseIconLoader.vue';

interface IProps {
	routeAddress: string;
	activeRouteName: string;
	routeName: string;
	label: string;
	iconName: string;
	customRuleActivation?: boolean;
	hasBadge?: boolean;
}

const props = defineProps<IProps>();

const isActiveRoute = computed(() => props.customRuleActivation ?? props.activeRouteName === props.routeName);

const activeClassModifier = computed(() =>
	isActiveRoute.value ? 'bg-primary-gradient text-white shadow-lg shadow-primary/20' : 'text-black-400 hover:bg-slate-50 hover:text-black',
);
</script>

<template>
	<RouterLink :to="routeAddress" class="mx-5 my-0.5 rounded-2xl px-3 py-2 fade-animation" :class="activeClassModifier" :data-business-tour="`nav-${routeName}`">
		<div class="flex items-center gap-3">
			<span class="relative inline-flex h-[26px] w-[26px] items-center justify-center">
				<BaseIconLoader :name="iconName" size="26px" :fill="isActiveRoute ? 'white' : 'black'" />
				<span v-if="hasBadge" class="absolute -left-1 -top-1 h-2.5 w-2.5 rounded-full bg-[#ff2d2d] ring-2 ring-white" aria-hidden="true" />
			</span>
			<span class="mt-1 truncate text-sm font-medium"> {{ label }} </span>
		</div>
	</RouterLink>
</template>
